import React from 'react';

import * as TPLeadAction from "../redux/actions/adminActions";
import * as TPUserLeadAction from "../redux/actions/subAdminActions";
import * as BrandCombinationAction from "../redux/actions/brandCombinationAction";
import * as SourceCombinationAction from "../redux/actions/sourceCombinationAction";
import * as SubSourceCombinationAction from "../redux/actions/subSourceCombinationAction";

import { fetchColumns as fetchAllColumns } from "../redux/slices/columnsSlice";
import { fetchColumns as fetchBrandCombinationColumns } from "../redux/slices/brandCombinationColumnSlice";
import { fetchColumns as fetchSourceCombinationColumns } from "../redux/slices/sourceCombinationColumnSlice";
import { fetchColumns as fetchSubSourceColumnCombination } from "../redux/slices/subSourceCombinationColumnSlice";

const tableConfig = {
    BrandCombination: {
        actions: BrandCombinationAction,
        selector: (state) => state.brandCombination,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        permissionKey: "BRANDCOMBINATION",
        search: false,
        columnType: "BrandCombination",
        leadAction: {
            create: true,
            edit: true,
            delete: true,
            view: false,
        }
    },
    SourceCombination: {
        actions: SourceCombinationAction,
        selector: (state) => state.sourceCombination,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        permissionKey: "SOURCE",
        search: false,
        columnType: "Source",
        leadAction: {
            create: false,
            edit: false,
            delete: false,
            view: false,
        }
    },
    SubSourceCombination: {
        actions: SubSourceCombinationAction,
        selector: (state) => state.subSourceCombination,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        permissionKey: "SUBSOURCE",
        search: false,
        columnType: "SubSource",
        leadAction: {
            create: true,
            edit: true,
            delete: true,
            view: false,
        }
    },
    TpLeads: {
        actions: TPLeadAction,
        selector: (state) => state.admin,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        permissionKey: "TP_LEADS",
        columnType: "TpLeads",
        search: true,
        leadAction: {
            create: true,
            edit: false,
            delete: false,
            view: false,
        }
    },
    TPUsers: {
        actions: TPUserLeadAction,
        selector: (state) => state.subadmin,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        permissionKey: "TP_USER",
        columnType: "TpUsers",
        search: true,
        leadAction: {
            create: true,
            edit: true,
            delete: false,
            view: false,
        }
    },
};

export default tableConfig;